.wrapper {
  display: flex;
  flex-direction: column;
}

.loader {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  min-height: 4rem;
  max-height: 4rem;
}

.tableWrapper {
  background-color: var(--white);
  padding: 0 0 2rem 0;
  border-radius: 0 0 8px 8px;
  font-family: 'Aeroport';
}

.table {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background-color: var(--white);
  padding-left: 2rem;
}

.column {
  display: flex;
  flex-direction: column;
  padding-right: 2rem;
  width: 50%;
}

@media screen and (max-width: 768px) {
  .column {
    width: 100%;
  }
}

@media screen and (min-width: 1216px) {
  .column {
    width: 33.33%;
  }
}

.buttons {
  padding-top: 2rem;
}

.signupCode {
  font-size: 1.4rem;
  color: var(--primary);
  padding: 0 0.6rem;
}

.error {
  font-size: 1rem;
  color: var(--danger);
}

.required {
  padding-left: 2rem;
  color: var(--gray-darker);
  font-size: 0.8rem;
  font-style: italic;
}

.asterisk {
  color: var(--danger-hover);
}
